import React, { useState } from 'react';
import axios from 'axios';
import { saveAs as saveFileFromUrl } from 'file-saver';
import { Progress, Icons, TaxarooButton } from 'taxaroo-ui';
import { useTranslation } from 'react-i18next';

const { DownloadOutlined } = Icons;
interface DownloadFileProps {
  getUrl?: () => Promise<string>;
  url?: string;
  name: string;
}

const DownloadFile = ({ getUrl, url, name }: DownloadFileProps) => {
  const { t: translation } = useTranslation();
  const [downloadState, setDownloadState] = useState(false);
  const [percentState, setPercentState] = useState(0);
  const [error, setError] = useState(null);

  const download = async () => {
    const uri = url || await getUrl();
    setDownloadState(true);
    axios.get(uri, {
      responseType: 'blob',
      onDownloadProgress(e) {
        setPercentState(Math.ceil((e.loaded / e.total) * 100));
      },
    })
      .then((response) => {
        const file = new File([response.data], name);
        saveFileFromUrl(file, name);
        setDownloadState(false);
        setPercentState(0);
        setError(null);
      })
      .catch((err) => {
        if (err) {
          setError(translation('chat.downloadFile.error'));
        }
      });
  };
  return (
    <>
      {downloadState && !error && (
        <div>
          <Progress percent={percentState} size="small" />
        </div>
      )}
      {!downloadState && !error && (
        <TaxarooButton type="default" icon={<DownloadOutlined style={{ marginLeft: 0 }} />} size="middle" onClick={download} />
      )}
      {error && (
        <p>{error}</p>
      )}
    </>
  );
};

DownloadFile.defaultProps = {
  getUrl: null,
  url: null,
};

export default DownloadFile;
